export const Feature40DataSource = {
  wrapper: { className: 'home-page-wrapper contact-wrapper' },
  OverPack: { className: 'home-page contact' },
  textWrapper: { className: 'contact-text', xs: 24, md: 10 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: 'nav.contact',
        className: 'title-h1',
      },
    ],
  },
  img: {
    children: 'map',
    className: 'contact-img',
    xs: 24,
    md: 14,
  },
  block: {
    children: [
      {
        name: 'block0',
        img: {
          children: require('@/assets/image/address.png'),
          className: 'contact-icon',
        },
        title: { className: 'contact-title', children: 'contact.address' },
        content: {
          className: 'contact-content',
          children: 'contact.addressContent'
        },
      },
      // {
      //   name: 'block1',
      //   img: {
      //     className: 'contact-icon',
      //     children:require('@/assets/image/phone.png'),
      //   },
      //   title: { className: 'contact-title', children: 'contact.phone' },
      //   content: {
      //     className: 'contact-content',
      //     children:'contact.phoneNumber',
      //   },
      // },
      {
        name: 'block2',
        img: {
          className: 'contact-icon',
          children: require('@/assets/image/email.png')
        },
        title: { className: 'contact-title', children: 'contact.business' },
        content: {
          className: 'contact-content',
          children: 'contact.businessEmail',
        },
      },
      {
        name: 'block3',
        img: {
          className: 'contact-icon',
          children: require('@/assets/image/email.png')
        },
        title: { className: 'contact-title', children: 'contact.hr' },
        content: {
          className: 'contact-content',
          children: 'contact.hrEmail',
        },
      },
    ],
  },
};
